import { createWebHistory, createRouter } from "vue-router";
import Contragents from "@/components/Contragents.vue";
// import Stores from "@/components/Stores.vue";
import Products from "@/components/Products";
import Deliveries from "@/components/Deliveries";
import Sales from "@/components/Sales";
import Consumptions from "@/components/Consumptions";
import StockTurnover from "@/components/StockTurnover";
import StockSales from "@/components/StockSales";
import Login from "@/components/Login";

const routes = [
  // {
  //   path: "/stores",
  //   name: "Обекти",
  //   component: Stores,
  // },
  {
    path: "/contragents",
    name: "Контрагенти",
    component: Contragents,
  },
  {
    path: "/products",
    name: "Продукти",
    component: Products,
  },
  {
    path: "/deliveries",
    name: "Доставки",
    component: Deliveries,
  },
  {
    path: "/sales",
    name: "Продажби",
    component: Sales,
  },
  {
    path: "/consumptions",
    name: "Изписване на стока",
    component: Consumptions,
  },
  {
    path: "/stock-turnover",
    name: "Стоков оборот",
    component: StockTurnover,
  },
  {
    path: "/stock-sales",
    name: "Продажби за период",
    component: StockSales,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
